module.exports = __webpack_public_path__ + "static/media/img_map@3x.3fc0d6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_map@3x.png
// module id = 871
// module chunks = 0